import { ActionSubType } from 'api/volops';

export const ACTION_SUB_TYPE: Array<{
  id: ActionSubType | 'NONE';
  name: string;
}> = [
  {
    id: 'NONE',
    name: '',
  },
  {
    id: 'RALLY_MARCH',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Rally / March'),
  },
  {
    id: 'FUNDRAISER',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Fundraiser'),
  },
  {
    id: 'OPEN_HOUSE',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Open House'),
  },
  {
    id: 'CONFERENCE',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Conference'),
  },
  {
    id: 'WEBINAR',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Webinar'),
  },
  {
    id: 'WORKSHOP',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Workshop'),
  },
  {
    id: 'OTHER',
    name:
      /* TRANSLATORS: "Volunteer +" type */
      getText('Other Opportunity'),
  },
];
